import queryString from '@utils/queryString'

const API_URL = {
  AUTH: {
    ME: 'auth/users/me/',
    SIGNUP: 'auth/users/',
    LOGIN: '/auth/jwt/create/',
    TOKEN_VERIFY: 'token-verify/',
    TOKEN_REFRESH: 'token-refresh/',
    ACTIVATION: 'auth/users/activation/',
    RESEND_VERIFICATION: 'auth/users/resend_activation/',
    RESET_PASSWORD: 'auth/users/reset_password/',
    RESET_PASSWORD_CONFIRM: 'auth/users/reset_password_confirm/',
    SET_PASSWORD: 'auth/users/set_password/',

    PATCH_USER: id => `auth/users/${id}/`
  },

  ACCOUNTING: {
    GET_ACCOUNTING_LIST: org_pk => `accounting/${org_pk}/`,
    GET_ACCOUNTING_TAXCODE_LIST: org_pk => `accounting/taxcode/${org_pk}/`,
    GET_ACCOUNTING_PERIODS_LIST: org_pk =>
      `accounting/accounting_periods/${org_pk}/`,

    POST_ACCOUNTING_LIST: (org_pk, team_pk) =>
      `/accounting/${org_pk}/?team=${team_pk}/`,
    POST_ACCOUNTING_PERIODS_LIST: org_pk =>
      `accounting/accounting_periods/${org_pk}/`,

    PATCH_ACCOUNTING: id => `accounting/${id}/`,
    PATCH_ACCOUNTING_TAXCODE: id => `accounting/taxcode/${id}/`,
    PATCH_ACCOUNTING_PERIOD: id => `accounting/accounting_periods/${id}/`,

    DELETE_ACCOUNTING: id => `accounting/${id}/`,
    DELETE_ACCOUNTING_TAXCODE: id => `accounting/taxcode/${id}/`,
    DELETE_ACCOUNTING_PERIOD: id => `accounting/accounting_periods/${id}/`,
    POST_ACCOUNTING_TAXCODE_LIST: orgPk => `accounting/taxcode/${orgPk}/`
  },

  ACTIONS: {
    LIST: `actions/`
  },

  BANKS: {
    GET_BANKS_LIST_PK: () => `banks/`,
    GET_ALL_BANKS: `banks/`,
    // POST_BANK_LIST_PK: org_pk => `banks/${org_pk}/`,
    POST_BANK_LIST_PK: `banks/`,
    POST_BANK: `banks/`,
    GET_BANK_ID: id => `banks/${id}/`,
    PATCH_BANK_ID: id => `banks/${id}/`,
    DELETE_BANK_ID: id => `banks/${id}/`,

    POST_MATCH_TRANSACTION: () => `treasuries/transaction_matches/`,

    GET_TREASURIES: bankId => `treasuries/connect/${bankId}/`,
    GET_ALL_TRANSACTION_MATCHES: () => `treasuries/transaction_matches/`,
    GET_TRANSACTION_MATCHES: transactionId =>
      `treasuries/transaction_matches/${transactionId}/`,

    PATCH_FORCE_SYNC: bankId => `treasuries/force_sync/${bankId}/`,
    PATCH_MATCH_TRANSACTION: matchId =>
      `treasuries/transaction_matches/${matchId}/`,

    DELETE_CONNECTED_USER: bankId =>
      `treasuries/connect/${bankId}/delete_user/`,
    DELETE_TRANSACTION_MATCHES: matchId =>
      `treasuries/transaction_matches/${matchId}/`
  },

  PROJECT: {
    GET_LIST: `
    /`, // A SUPPRIMER ?
    BULK_ADD: (orgId, userId) =>
      `projects/users/bulk/add/${orgId}/?team=${userId}`,
    BULK_DELETE: (orgId, userId) =>
      `projects/users/bulk/delete/${orgId}/?team=${userId}`,
    GET_DELIVERABLES_BUDGET_ROLES: pId =>
      `projects/deliverables/${pId}/budget_roles/`,
    GET_DELIVERABLES_TIMELINE: pId => `projects/deliverables/${pId}/timeline/`,
    GET_DELIVERABLES_INVOICING: pId =>
      `projects/deliverables/${pId}/invoicing/`,
    GET_DELIVERABLES_BUDGET: pId =>
      `projects/deliverables/${pId}/budget_users/`,
    GET_DELIVERABLES_CONTRACTORS: project_pk =>
      `projects/deliverables/${project_pk}/contractors/`,
    POST_PROJECTS_FAVORITE: project_pk => `projects/favorite/${project_pk}/`,
    GET_DELIVERABLES_PERIODS: project_pk =>
      `projects/deliverables/${project_pk}/periods/`
  },

  ORG_USER: {
    EXPORT_ORG_USER: id => `orgusers/export/${id}/`,
    GET_ALL_ORG_USERS: () => 'orgusers/',
    GET_MY_ORG_USER: () => 'orgusers/me/',
    GET_ORG_USERS: id => `orgusers/${id}/`,
    GET_ORG_USER_COUNT: id => `orgusers/count/${id}/`,
    GET_ORG_USER_PK: () => `orgusers/`,
    GET_ORG_USER: (user_pk, team_pk) => `orgusers/${user_pk}/?team=${team_pk}`,
    GET_ORG_USER_LIST: (orgId, teamId, projectId) =>
      `orgusers/${orgId}/?team=${teamId}&all_users=true&exclude_archived=true&page_size=9999&for_project=${projectId}`,
    GET_ORG_USER_LIST_GLOBAL: (orgId, teamId) =>
      `orgusers/${orgId}/?team=${teamId}`,
    GET_ORGANIZATIONS: 'organizations/membership/',
    GET_VALIDATION_METRICS: 'orgusers/validation_metrics/',
    GET_USER: () => 'orgusers/me/',

    POST_ORGUSER_LIST: org_pk => `orgusers/${org_pk}/?is_v4=true`,
    POST_ORGANIZATION: 'organizations/',
    // POST_ORG_USER_INVITE: `orgusers/invite/?is_v4=true`,
    POST_ORG_USER_INVITE: `invitations/`,

    UPDATE_ORG_USER: userId => `orgusers/${userId}/`,

    DELETE_ORG_USER: id => `orgusers/${id}/`,
    DELETE_ORG_USER_TEAM: (id, teamId) => `orgusers/${id}/?team=${teamId}`
  },

  PERMISSIONS: {
    GET_PERMISSIONS_LIST: id => `permissions/${id}/`,
    GET_PERMISSION_DETAILS: id => `permissions/${id}/permissions_detail/`,
    GET_PERMISSION: id => `permissions/${id}/`,
    GET_PERMISSIONS_MAP: 'permissions/map/',

    POST_PERMISSIONS_LIST: org_pk => `permissions/${org_pk}/`,
    PATCH_PERMISSION: id => `permissions/${id}/`,
    DELETE_PERMISSION: id => `permissions/${id}/`
  },

  CLIENTS: {
    GET_CLIENT_PK: id => `clients/${id}/`,
    GET_CLIENTS_LIST_PK: id => `clients/${id}/`,
    GET_CLIENTS_LIST_BY_PROJECT: (orgId, projectId) =>
      `clients/${orgId}/?project=${projectId}`,
    GET_CLIENTS_PROJECT_LIST: (orgId, projectId) =>
      `clients/project/${orgId}/?project=${projectId}`,
    GET_CLIENTS_GROUP_LIST_PK: org_pk => `clients/group/${org_pk}/`,
    GET_CLIENTS_GROUP_BY_PROJECT: (orgId, projectId) =>
      `/clients/group/${orgId}/?project=${projectId}`,
    GET_CLIENTS_SPLIT_LIST: (orgId, projectId) =>
      `clients/split/${orgId}/?project=${projectId}`,
    GET_CLIENTS_SPLIT_PK: id => `clients/split/${id}/`,

    POST_APPLY_DEFAULT_CONTACT_PK: client_pk =>
      `clients/${client_pk}/apply_default_contact/`,
    POST_CLIENTS_LIST_PK: id => `clients/${id}/`,
    POST_CLIENTS_LIST_BY_PROJECT: (orgId, projectId) =>
      `clients/${orgId}/?project=${projectId}`,
    POST_CLIENTS_PROJECT_LIST: (orgId, projectId) =>
      `clients/project/${orgId}/?project=${projectId}`,
    POST_CLIENTS_SPLIT_LIST: (orgId, projectId) =>
      `clients/split/${orgId}/?project=${projectId}`,
    POST_CLIENTS_GROUP_LIST: org_pk => `clients/group/${org_pk}/`,

    PATCH_CLIENTS_PK: id => `clients/${id}/`,
    PATCH_CLIENTS_PROJECT_PK: id => `clients/project/${id}/`,
    PATCH_CLIENTS_SPLIT_PK: id => `clients/split/${id}/`,
    PATCH_CLIENTS_GROUP: id => `clients/group/${id}/`,

    DELETE_CLIENTS_PROJECT_PK: id => `clients/project/${id}/`,
    DELETE_CLIENTS_SPLIT_PK: id => `clients/split/${id}/`,
    DELETE_CLIENTS_PK: id => `clients/${id}/`,
    DELETE_CLIENTS_GROUP: id => `clients/group/${id}/`
  },

  TENANTS: {
    POST_TENANT: () => `tenants/`,

    GET_TENANTS_LIST: () => `tenants/`,
    GET_TENANTS_LIST_BY_PROJECT: id => `tenants/?operations=${id}`,
    GET_TENANT_BY_ID: id => `tenants/${id}/`,

    GET_TENANT_INVOICES: tenantId => `invoices/?tenant=${tenantId}`,
    GET_TENANT_PAYMENTS: tenantId => `payments/?tenant=${tenantId}`,
    GET_TENANT_LEASES: tenantId => `leases/?tenant=${tenantId}`,

    PATCH_TENANT_BY_ID: id => `tenants/${id}/`,
    PATCH_TENANT_FILE: id => `tenants/${id}/`,

    DELETE_TENANT_BY_ID: id => `tenants/${id}/`
  },

  PROJECTS: {
    GET_PROJECT_PK: id => `operations/${id}/`,
    GET_PROJECTS_AVAILABLE_CLIENT: id => `operations/available-clients/${id}/`,
    GET_PROJECTS_USER_LIST: id => `operations/users/?operation=${id}`,
    GET_PROJECT_LIST_SIGNED: `operations/?signed=true&page_size=9999`,
    GET_PROJECT_TAGS_LIST: id => `operations/tags/${id}/`,
    GET_PROJECT_LIST_PK: `operations/`,
    GET_PROJECT_LIST_ACCESS: `operations/list/access/`,
    GET_PROJECT_USERS: `operations/users/`,
    GET_PROJECT_USER_LIST: `operations/users/list/`,
    GET_PROJECT_GROUPS_BY_ORG: orgId => `projects/tags/groups/${orgId}/`,
    GET_PROJECTS_DELIVERABLES_INVOICING_SCHEDULE_PLANNING: () =>
      `projects/deliverables/invoicing_schedule_contractor/`,
    GET_PROJECTS_DELIVERABLES_INVOICING_SCHEDULE_PK: id =>
      `projects/deliverables/${id}/invoicing_schedule/`,
    GET_PROJECTS_DELIVERABLES_FINANCE_PK: id =>
      `projects/deliverables/${id}/finance/`,
    GET_PROJECT_CLIENT_SPLIT: id => `projects/deliverables/${id}/client_split/`,
    GET_PROJECT_STATS_PROGRESS: pId => `projects/stats/${pId}/progress/`,
    GET_PROJECT_STATS_HOURS: pId => `projects/stats/${pId}/hours/`,
    GET_PROJECT_DELIVERABLES_PROGRESS: pId =>
      `projects/deliverables/${pId}/progress/`,
    GET_PROJECT_DELIVERABLES_FEES: pId => `projects/deliverables/${pId}/fees/`,
    GET_PROJECT_DELIVERABLES_FEES_TIME: pId =>
      `projects/deliverables/${pId}/fees_time/`,
    GET_PROJECT_INVOICING: id => `projects/deliverables/${id}/invoicing/`,
    GET_PROJECTS_DASHBOARD: orgPk => `projects/projects-dashboard/${orgPk}/`,
    GET_PROJECT_TIMELINE: orgPk => `projects/project_timeline/${orgPk}/`,
    GET_PROJECTS_WITH_ALERTS: orgPk =>
      `projects/projects_with_alerts/${orgPk}/`,
    GET_PROJECT_SUMMARY_CHART: orgPk =>
      `projects/project_summary_chart/${orgPk}/`,
    GET_PROJECTS_FINANCIAL_RATIOS: 'projects/financial_ratios/',
    GET_PROJECTS_EXPORT: org_pk => `projects/export/${org_pk}/`,
    GET_PROJECTS_UNPAID_HISTORY: team_pk =>
      `projects/unpaid_history/?team=${team_pk}`,
    GET_PROJECT_LEASE_ARTICLES: operationId =>
      `/operations/${operationId}/lease_articles/`,

    POST_PROJECT_LIST_PK: `operations/`,
    POST_PROJECT_TAGS_LIST: id => `operations/tags/${id}/`,
    POST_PROJECT_ACTIONS_PK: (id, action) =>
      `operations/actions/${id}/?action=${action}/`,
    POST_PROJECT_ACTION: org_pk => `operations/actions/${org_pk}/`,
    POST_PROJECT_TAG_GROUPS_LIST: org_pk => `operations/tags/groups/${org_pk}/`,
    POST_PROJECT_USERS_LIST_ACTION: (org_pk, team_pk) =>
      `operations/users/list/action/?org=${org_pk}&team=${team_pk}`,
    POST_PROJECT_USERS: `operations/users/`,

    PATCH_PROJECT_PK: id => `operations/${id}/`,
    PATCH_PROJECT_USERS_PK: id => `operations/users/${id}/`,
    PATCH_PROJECTS_TAGS_PK: id => `operations/tags/${id}/`,
    PATCH_PROJECT_TAG_GROUP: id => `operations/tags/groups/${id}/`,

    DELETE_PROJECT: id => `operations/${id}/`,
    DELETE_PROJECT_USERS_PK: id => `operations/users/${id}/`,
    DELETE_PROJECTS_TAGS_PK: id => `projects/tags/${id}/`,
    DELETE_PROJECT_TAG_GROUP: id => `projects/tags/groups/${id}/`,

    POST_PROJECTS_USER_BULK_ADD: org_pk => `projects/users/bulk/add/${org_pk}/`,
    DELETE_PROJECTS_USER_BULK: org_pk => `projects/users/bulk/delete/${org_pk}/`
  },

  FEES_PROJECTS: {
    GET_FEES_PROJECTS_LIST_PK: org_pk => `fees/projects/${org_pk}/`,
    GET_FEES_PROJECTS_PK_BY_PROJECT: (id, pId) =>
      `fees/projects/${id}/?project=${pId}`,
    GET_FEES_PROJECTS_PK: id => `fees/projects/${id}/`,
    GET_FEES_BRACKETS_LIST: project_pk => `fees/bracket/${project_pk}/`,
    GET_FEES_PROJECT_VERSIONS_LIST: org_pk =>
      `fees/fee-project-version/${org_pk}/`,
    GET_FEES_ZONES_LIST: fee_project_pk =>
      `fees/zones/load/?fee_project=${fee_project_pk}`,
    GET_FEES_APPLY_PROJECT_DEFAULTS: (fee_project_pk, is_price) =>
      `fees/apply-project-defaults/${fee_project_pk}/${is_price}/`,

    POST_FEES_PROJECTS_LIST_PK: (orgId, projectId) =>
      `fees/projects/${orgId}/?project=${projectId}`,
    POST_FEES_BRACKETS_LIST: project_pk => `fees/bracket/${project_pk}/`,
    POST_FEES_PROJECT_VERSIONS_LIST: org_pk =>
      `fees/fee-project-version/${org_pk}/`,
    POST_FEES_ZONES_UPDATE: `fees/zones/update/`,
    POST_FEES_VALIDATE_COSTS: project_pk =>
      `fees/validate_costs/${project_pk}/`,

    PATCH_FEES_PROJECTS_PK: id => `fees/projects/${id}/`,
    PATCH_FEES_BRACKET: id => `fees/bracket/${id}/`,
    PATCH_FEE_PROJECT_VERSION: id => `fees/fee-project-version/${id}/`,
    PATCH_FEES_ZONE: id => `fees/zones/${id}/`,

    DELETE_FEES_PROJECTS_PK: id => `fees/projects/${id}/`,
    DELETE_FEES_BRACKET: id => `fees/bracket/${id}/`,
    DELETE_FEE_PROJECT_VERSION: id => `fees/fee-project-version/${id}/`,
    DELETE_FEES_ZONE: id => `fees/zones/${id}/`
  },
  MANDATES: {
    GET_MANDATES: () => `mandates/`,
    GET_MANDATE: mandateId => `mandates/${mandateId}/`,

    POST_MANDATES: `mandates/`,

    PATCH_MANDATES: id => `mandates/${id}/`,

    DELETE_MANDATES: id => `mandates/${id}/`
  },

  PROFILES: {
    GET_PROFILES_PROFILE: `profiles/profile/`,
    GET_ONBOARDING_PROGRESS: orgId => `profiles/onboarding/${orgId}/`,
    GET_PROFILES_USER: `profiles/user/`,

    POST_ACTIVATE_2FA: 'profiles/activate_2fa/',
    POST_DISABLE_2FA: 'profiles/disable_2fa/',
    POST_OBTAIN_TOKEN: 'profiles/obtain_token/',
    POST_VERIFY_2FA: 'profiles/verify_2fa/',
    POST_UNVERIFY_2FA: 'profiles/unverify_2fa/',
    PATCH_PROFILES_PROFILE: `profiles/profile/`,
    PATCH_PROFILES_USER: `profiles/user/`,
    POST_INVITE_USER: 'invitations/'
  },

  PHASES: {
    GET_PHASE_PK: id => `phases/${id}/`,
    GET_PHASES_PK: id => `phases/${id}/`,
    GET_PHASES_PK_BY_FEE_PROJECT: (id, fpId) =>
      `phases/${id}/?page_size=9999&fee_project=${fpId}`,
    GET_PLANPHASES: id => `phases/planphases/${id}/`,
    GET_DELIVERABLE_PROGRESS_DETAIL: id =>
      `phases/deliverable-progress-detail/${id}/`,

    POST_PHASES_PK: id => `phases/${id}/`,
    POST_PHASES_TOGGLE: `phases/toggle/`,
    POST_PHASES_ACTION: org_pk => `phases/action/${org_pk}/`,

    PATCH_PHASES_PK: id => `phases/${id}/`,

    DELETE_PHASES_PK: id => `phases/${id}/`,
    DELETE_ALL_PHASES_PK_BY_FEE_PROJECT: (pId, fpId) =>
      `phases/delete/${pId}/?fee_project=${fpId}`
  },

  MILESTONES: {
    GET_MILESTONES: (orgId, pId) =>
      pId ? `milestones/${orgId}/?project=${pId}` : `milestones/${orgId}/`,
    GET_MILESTONE: id => `milestones/${id}/`,
    POST_MILESTONE: (orgId, pId) => `milestones/${orgId}/?project=${pId}`,
    PATCH_MILESTONE: id => `milestones/${id}/`,
    DELETE_MILESTONES: id => `milestones/${id}/`
  },

  OCR: {
    INVOICE: () => `/OCR/extract_data/invoices/`,
    EXPENSE: `/ocr/extract-data/`
  },

  ROLES: {
    ALL_ROLES: id => `roles/${id}/`,
    ROLE: id => `roles/${id}/`,
    GET_PROJECT_ROLES: (org_pk, project_pk) =>
      `roles/project/${org_pk}/?project=${project_pk}`,
    GET_TEAM_ROLES: (org_pk, team_pk) => `roles/${org_pk}/?team=${team_pk}`,
    POST_TEAM_ROLES: (org_pk, team_pk) => `roles/${org_pk}/?team=${team_pk}`,
    PATCH_ROLES_PROJECT: id => `roles/project/${id}/`,
    PATCH_ROLES: id => `roles/${id}/`,
    DELETE_ROLES: id => `roles/${id}/`
  },

  STATS: {
    GET_INDICATOR_COST: 'stats/indicators/cost/',
    GET_INVOICE_PLANNING: 'stats/invoice_planning/',
    RENTROLL: project_pk => `stats/rentroll/?operation_pk=${project_pk}`
  },
  TASKS: {
    GET_TASK: id => `tasks/${id}/`,
    // GET_TASK_LIST: id => `tasks/${id}/`,
    GET_TASK_LIST: () => `tasks/`,
    GET_TASKS_LABEL_LIST: id => `tasks/label/${id}/`,
    GET_TASKS_LISTS_LIST: () => `tasks/lists/`,
    POST_TASKS_LIST: () => `tasks/`,
    PATCH_TASKS: id => `tasks/${id}/`,
    DELETE_TASKS: id => `tasks/${id}/`,
    POST_TASKS_LOG_TAKS: id => `tasks/log-tasks/${id}/`,
    CREATE_TASK: () => `tasks/`
  },

  EVENTS: {
    GET_EVENTS_LIST: `events/`,
    GET_EVENT: id => `events/${id}/`,

    POST_EVENT: `events/`,
    PATCH_EVENT: id => `events/${id}/`,
    DELETE_EVENT: id => `events/${id}/`
  },

  POSTS: {
    GET_POSTS: id => `posts/${id}/`,
    // GET_POSTS_TAGS: id => `posts/tags/${id}/`,
    GET_POSTS_TAGS: () => `posts/tags/`,
    GET_POSTS_LIKE_LIST: () => `posts/like/`,
    // GET_POSTS_LIST: id => `posts/${id}/`,
    GET_POSTS_LIST: () => `posts/`,
    GET_POSTS_IMAGE_LIST: id => `posts/image/${id}/`,
    GET_POSTS_POST_COMMENTS: id => `posts/post/comments/${id}/`,
    GET_LAST_POST: orgPk => `posts/last-post/${orgPk}/`,

    // POST_POSTS_LIST: id => `posts/${id}/`,
    POST_POSTS_LIST: () => `posts/`,
    POST_POST_IMAGE: org_pk => `posts/image/${org_pk}/`,
    // POST_POST_ALBUM: org_pk => `posts/album/${org_pk}/`,
    POST_POST_ALBUM: () => `posts/album/`,

    PATCH_POSTS: id => `posts/${id}/`,
    PATCH_POST_IMAGE: id => `posts/image/${id}/`,
    DELETE_POSTS: id => `posts/${id}/`,
    POST_POSTS_LIKE_LIST: () => `posts/like/`,
    DELETE_POSTS_LIKE: id => `posts/like/${id}/`,
    DELETE_POST_IMAGE: id => `posts/image/${id}/`
  },

  NOTES: {
    GET_NOTES_LIST: id => `notes/${id}/`,
    POST_NOTES_LIST: id => `notes/${id}/`,
    PATCH_NOTES: id => `notes/${id}/`,
    DELETE_NOTES: id => `notes/${id}/`
  },

  CURRENCIES: {
    GET_CURRENCY_PK: id => `currencies/${id}/`,
    GET_CURRENCIES_DEFAULT: `currencies/default/`,
    GET_CURRENCIES_LIST: `currencies/?page_size=9999999`,
    GET_CURRENCIES_SELECTED: `currencies/?settings=true&is_selected=true`,
    GET_CURRENCIES_NOT_SELECTED: `currencies/?page_size=9999999&settings=true&is_selected=false`,
    POST_CURRENCIES_LIST_ACTION_PK: org_pk =>
      `currencies/list/actions/${org_pk}/`,

    POST_CURRENCY: `currencies/`,

    DELETE_CURRENCY: id => `currencies/${id}/`
  },

  COUNTRIES: {
    GET_COUNTRIES: `organizations/countries/`
  },

  CITIES: {
    GET_CITIES: `projects/cities/`
  },

  LANGUAGES: {
    GET_LANGUAGES: `organizations/languages/`
  },

  ORGANIZATIONS: {
    GET_ADMIN_DASHBOARD_METRICS_BY_TEAM: team_pk =>
      `organizations/admin-dashboard-metrics/${team_pk}/`,
    GET_ADMIN_DASHBOARD_METRICS: `organizations/admin-dashboard-metrics/`,
    GET_DASHBOARD_METRICS: `organizations/dashboard-metrics/`,
    GET_MEMBERSHIP: `organizations/membership/`,
    GET_ORGANIZATION_METRICS: org_pk => `organizations/metrics/${org_pk}/`,
    GET_ORGANIZATION: id => `organizations/${id}/`,
    GET_PERIODS: `organizations/periods/`,
    GET_BUDGETS_USERS: team_pk => `organizations/budgets-users/${team_pk}/`,

    PATCH_ORGANIZATION: id => `organizations/${id}/`,
    PATCH_TRANSFER_OWNERSHIP: id => `organizations/transfer-ownership/${id}/`
  },

  INVOICES: {
    GET_INVOICE_PREVIEW: invoice_id => `invoices/preview/${invoice_id}/`,
    GET_BILLABLE_SUMMARY: team_pk => `invoices/billable-summary/${team_pk}/`,
    GET_UNPAID_COMPOSITION_CHARTS: team_pk =>
      `invoices/unpaid-composition-charts/${team_pk}/`,
    GET_REVENUE_COMPOSITION_CHARTS: team_pk =>
      `invoices/revenue-composition-charts/${team_pk}/`,
    GET_ACCOUNTING_DASHBOARD: team_pk =>
      `invoices/accounting-dashboard/${team_pk}/`,
    GET_INVOICES_METRICS: org_pk => `invoices/metrics/`,
    GET_INVOICES_LIST_PK: () => `invoices/`,
    GET_INVOICE_ITEM_UPDATE: id => `/invoices/items/update/${id}/`,
    GET_INVOICE_PK: id => `invoices/${id}/`,
    GET_INVOICE_ITEMS_PK: invoice_id => `invoices/${invoice_id}/items/`,
    GET_INVOICING_METRICS: (team_pk, project_pk) =>
      `invoices/invoicing-metrics/${team_pk}/${project_pk}/`,
    GET_INVOICES_FOLLOWUP_RULES_LIST: org_pk =>
      `invoices/followup/rule/${org_pk}/`,
    GET_CONTRACT_ITEMS: id => `invoices/contract/items/${id}/`,
    GET_CONTRACT_ITEM: id => `invoices/contract/item/${id}/`,
    POST_SYNC_CLIENT: id => `invoices/${id}/sync-clients/`,
    GET_INVOICES_LIST_BY_STATUS_PK: (org_pk, team_pk) => ({
      draft:
        `invoices/` +
        '?' +
        queryString({
          status: ['not_valid', 'not_valid_auto'],
          team: team_pk,
          org: org_pk
        }),
      to_send:
        `invoices/` +
        '?' +
        queryString({
          status: 'not_sent',
          is_valid: true,
          is_scheduled: false,
          team: team_pk
        }),
      scheduled:
        `invoices/` +
        '?' +
        queryString({ status: 'not_sent', is_scheduled: true, team: team_pk }),
      open:
        `invoices/` +
        '?' +
        queryString({
          status: ['not_paid', 'partial', 'late', 'litigious'],
          team: team_pk
        }),
      closed:
        `invoices/` +
        '?' +
        queryString({ status: ['paid', 'canceled', 'closed'], team: team_pk })
    }),
    GET_INVOICES_PERIODS: (org_pk, team_pk) =>
      `invoices/accounting_periods/${org_pk}/?team=${team_pk}`,
    GET_INVOICES_PERIODS_PER_PROJECT: (org_pk, team_pk) =>
      `invoices/accounting_periods_per_project/${org_pk}/?team=${team_pk}`,
    GET_INVOICE_GENERATE_PDF: id => `invoices/${id}/pdf/`,
    GET_INVOICES_FOLLOWUPS: org_pk => `invoices/followup/${org_pk}/`,
    GET_INVOICE_FOLLOWUP: id => `invoices/followup/${id}/`,
    GET_INVOICES_COUNT: () => `invoices/count/`,

    POST_INVOICES_SYNC_CONTRACT_INVOICE_PROGRESS: id =>
      `/invoices/${id}/sync-contract-invoice-progress/`,
    POST_INVOICES_CONTRACT_ITEM_GENERATE: id =>
      `invoices/contract/item/generate/${id}/`,
    POST_INVOICE_PREVIEW: org_pk => `invoices/preview/${org_pk}/`,
    POST_RESET_ORDERS: id => `invoices/${id}/reset-orders/`,
    POST_REMOVE_FEE_PROJECT_TITLES: id =>
      `invoices/${id}/remove-fee-project-titles/`,
    POST_INVOICE_USER_LIST_PK: (org_pk, team_pk) =>
      `invoices/${org_pk}/?team=${team_pk}`,
    POST_INVOICES_FOLLOWUP_RULES_LIST: org_pk =>
      `invoices/followup/rule/${org_pk}/`,
    POST_GENERATE_AUTO_DRAFT_PK: (org_pk, team_pk) =>
      `invoices/generage-auto-draft-invoices/${org_pk}/?team=${team_pk}`,
    POST_INVOICES_ACTION: (org_pk, team_pk) =>
      `invoices/action/${org_pk}/?team=${team_pk}`,
    POST_INVOICE_ITEM: invoice_id => `invoices/${invoice_id}/items/`,
    POST_INVOICES_FOLLOWUP_ACTION: (org_pk, team_pk) =>
      `invoices/followup/action/?org=${org_pk}&team=${team_pk}`,
    POST_INVOICES_FOLLOWUP_GENERATE: (org_pk, team_pk) =>
      `invoices/followup/${org_pk}/generate/?team=${team_pk}`,
    POST_FOLLOWUP_SEND: id => `invoices/followup/${id}/send/`,
    POST_NOTIFY_CONTRACTORS: id => `invoices/${id}/notify-contractors/`,

    POST_INVOICES: () => 'invoices/',
    POST_GENERATE_INVOICE_ITEM: invoiceId =>
      `invoices/automation/${invoiceId}/`,

    PATCH_INVOICE_PK: id => `invoices/${id}/`,
    PATCH_INVOICE_ITEM: (invoiceId, id) =>
      `/invoices/${invoiceId}/items/${id}/`,
    PATCH_INVOICES_FOLLOWUP_RULE: id => `invoices/followup/rule/${id}/`,
    PATCH_CONTRACT_ITEM: id => `invoices/contract/item/${id}/`,
    PATCH_INVOICES_FOLLOWUP: id => `invoices/followup/${id}/`,

    DELETE_INVOICES_FOLLOWUP_RULE: id => `invoices/followup/rule/${id}/`,
    DELETE_INVOICES: id => `invoices/${id}/`,
    DELETE_INVOICE_ITEM_PK: (invoiceId, id) =>
      `/invoices/${invoiceId}/items/${id}/`,
    DELETE_CONTRACT_ITEM: id => `invoices/contract/item/${id}/`,
    DELETE_INVOICES_FOLLOWUP: id => `invoices/followup/${id}/`,

    GET_TEMPLATES: () => `invoices/suggestions/`,
    GENERATE_SUGGESTION: () => `invoices/generate_suggestions/`
  },

  EMAILS: {
    GET_EMAILS_LIST_PK: `emails/`,
    GET_SMTP_LIST_PK: `emails/smtp/`,
    POST_EMAIL_SEND_TEST: id => `emails/${id}/send-test/`,
    POST_EMAIL_APPLY: id => `emails/${id}/apply/`,
    POST_EMAIL_LIST: `emails/`,
    POST_SMTP_LIST: `emails/smtp/`,
    POST_SMTP_SEND_TEST: id => `emails/smtp/${id}/send-test/`,
    PATCH_SMTP: id => `emails/smtp/${id}/`,
    PATCH_EMAIL: id => `emails/${id}/`,
    DELETE_SMTP: id => `emails/smtp/${id}/`,
    DELETE_EMAIL: id => `emails/${id}/`
  },

  CONTRACTS: {
    GET_CONTRACTS_MONTH_LIST: org_pk => `contracts/month/${org_pk}/`,
    GET_CONTRACTS_CONTRACTOR: id => `contracts/contractor/${id}/`,
    GET_CONTRACTS_CONTRACTOR_LIST: org_pk => `contracts/contractor/${org_pk}/`,
    GET_CONTRACTS: orgId => `contracts/${orgId}/`,
    GET_CONTRACTS_ITEMS: org_pk => `contracts/item/${org_pk}/`,

    POST_CONTRACTS_LIST: orgId => `contracts/${orgId}/`,
    POST_CONTRACT_CONTRACTOR_LIST_PK: org_pk =>
      `contracts/contractor/${org_pk}/`,
    POST_CONTRACTOR_LIST_PROJECT: (orgId, pId) =>
      `contracts/contractor/${orgId}/?filter_project=${pId}`,
    POST_CONTRACTS_ITEM_LIST: id => `contracts/item/${id}/`,
    POST_CONTRACTS_MONTH_GENERATE: (org_pk, team_pk) =>
      `contracts/month/generate/${org_pk}/?team=${team_pk}`,
    POST_CONTRACTS_MONTH_LIST: (org_pk, team_pk) =>
      `contracts/month/${org_pk}/?team=${team_pk}`,

    PATCH_CONTRACTS: id => `contracts/${id}/`,
    PATCH_CONTRACTS_ITEM: id => `contracts/item/${id}/`,
    PATCH_CONTRACTS_MONTH: id => `contracts/month/${id}/`,

    DELETE_CONTRACTS: id => `contracts/${id}/`,
    DELETE_CONTRACTS_MONTH: id => `contracts/month/${id}/`
  },

  CONTRACTORS: {
    GET_CONTRACTORS_LIST: pId => `projects/deliverables/${pId}/contractors/`,
    GET_CONTRACTS_CONTRACTOR: id => `contracts/contractor/${id}/`,

    PATCH_CONTRACTS_CONTRACTOR: id => `contracts/contractor/${id}/`,
    DELETE_CONTRACTS_CONTRACTOR: id => `contracts/contractor/${id}/`
  },

  SUPPLIERS: {
    POST_SUPPLIER: () => `suppliers/`,
    POST_CONTRACT: () => `suppliers/contract/`,

    GET_SUPPLIERS_LIST: () => `suppliers/`,
    GET_SUPPLIERS_LIST_BY_PROJECT: id =>
      `suppliers/?page_size=9999&operations=${id}`,
    GET_SUPPLIER: supplierId => `suppliers/${supplierId}/`,
    GET_SUPPLIER_EXPENSES: supplierId => `expenses/?supplier=${supplierId}`,
    GET_SUPPLIER_CONTRACTS: supplierId =>
      `suppliers/contract/?supplier=${supplierId}`,

    GET_CONTRACTS: () => `suppliers/contract/`,
    GET_CONTRACT: contractId => `suppliers/contract/${contractId}/`,

    PATCH_SUPPLIER: supplierId => `suppliers/${supplierId}/`,
    PATCH_CONTRACT: contractId => `suppliers/contract/${contractId}/`,

    DELETE_SUPPLIER: supplierId => `suppliers/${supplierId}/`,
    DELETE_CONTRACT: contractId => `suppliers/contract/${contractId}/`
  },

  PAYMENTS: {
    POST_PAYMENT: invoiceId => `payments/?invoice=${invoiceId}`,
    GET_INVOICE_PAYMENTS: invoiceId =>
      `/payments/invoice-payment/?invoice=${invoiceId}`,
    GET_PEYMENTS_LIST_PK: () => `payments/`,
    GET_PAYMENT_PK: id => `payments/${id}/`,
    POST_PAYMENT_PK: `payments/`,
    PATCH_PAYMENT_PK: id => `payments/${id}/`,
    PATCH_PAYMENT_INVOIC_EPK: id => `payments/invoice/${id}/`,
    DELETE_PAYMENT_PK: id => `payments/${id}/`
  },

  IMPORTS: {
    GET_IMPORTS_LIST_PK: () => `imports/`,
    GET_EXPORTS_LIST_PK: org_pk => `imports/export/${org_pk}/`,
    GET_ALL_EXPORTS: `exports/`,
    GET_INVOICES_EXPORTS_LIST_PK: org_pk =>
      `imports/export/${org_pk}?type=9&type=16&type=10&type=11&type=12&type=13&type=21`,
    GET_COSTS_EXPORTS_LIST_PK: org_pk =>
      `imports/export/${org_pk}?type=10&type=14&type=23&type=29&type=32`,
    GET_IMPORT: id => `imports/${id}/`,
    GET_IMPORTS_IMPORT: (org_pk, type, pk) =>
      `/imports/import/${org_pk}/?type=${type}&pk=${pk}`,
    GET_DOWNLOAD_FILE: (org_pk, type, team_pk, project_pk) =>
      `imports/import/${org_pk}/?type=${type}&team=${team_pk}&project=${project_pk}`,
    GET_DOWNLOAD_SAMPLE: name => `imports/examples/${name}/`,
    POST_IMPORT_FILE: (org_pk, type, team_pk, project_pk) =>
      `/imports/import/${org_pk}/?type=${type}&team=${team_pk}&project=${project_pk}`,
    POST_IMPORT_CONTINUE: (org_pk, type, pk, team_pk, project_pk) =>
      `/imports/import/${org_pk}/?type=${type}&pk=${pk}&team=${team_pk}&project=${project_pk}`,
    POST_IMPORT_MAP_COLUMNS: id => `imports/${id}/map-columns/`,
    POST_EXPORT_LIST_PK: org_pk => `imports/export/${org_pk}/`,
    POST_CREATE_EXPORT: `exports/`,
    DELETE_IMPORT_ID: id => `imports/${id}/`,
    RUN_IMPORT_ID: id => `imports/${id}/run/`,
    DELETE_EXPORT_ID: id => `exports/${id}/`
  },

  REVENUES: {
    GET_REVENUE_MONTH_LIST_PK: org_pk => `revenue/month/${org_pk}/`,
    GET_REVENUE_MONTH_ID: id => `revenue/month/${id}/`,
    POST_REVENUE_MONTH_LIST_PK: org_pk => `revenue/month/${org_pk}/`,
    POST_REVENUE_SET_ANNUAL_BUDGET: id => `revenue/set-annual-budget/${id}/`,
    PATCH_REVENUE_MONTH_ID: id => `revenue/month/${id}/`,
    DELETE_REVENUE_MONTH_ID: id => `revenue/month/${id}/`,
    GET_REVENUE_LIST_PK: org_pk => `revenue/${org_pk}/`,
    GET_REVENUE_ID: id => `revenue/${id}/`,
    POST_REVENUE_LIST_PK: org_pk => `revenue/${org_pk}/`,
    PATCH_REVENUE_ID: id => `revenue/${id}/`,
    DELETE_REVENUE_ID: id => `revenue/${id}/`
  },

  STYLEGUIDES: {
    GET_STYLEGUIDES_PK: `styleguides/`,
    GET_STYLEGUIDES_FONTS: `styleguides/fonts/`,
    GET_STYLEGUIDE: id => `styleguides/${id}/`,

    POST_STYLEGUIDE: `styleguides/`,
    POST_DUPLICATE_STYLEGUIDE: (org_pk, id) =>
      `styleguides/duplicate/${org_pk}/?pk=${id}`,

    PATCH_STYLEGUIDE: id => `styleguides/${id}/`,
    DELETE_STYLEGUIDE: id => `styleguides/${id}/`
  },

  TAGS: {
    GET_TAGS_LIST: org_pk => `tags/${org_pk}/`,
    POST_TAGS_LIST: org_pk => `tags/${org_pk}/`,
    PATCH_TAG_EDIT: id => `tags/${id}/`,
    DELETE_TAG: id => `tags/${id}/`
  },

  TEAMS: {
    GET_TEAMS_ROLE_CHART: team_pk => `teams/role_chart/${team_pk}/`,
    GET_TEAMS_AVAILABILITY_ROLES: `teams/availability/roles/`,
    GET_TEAMS_AVAILABILITY_USERS: `teams/availability/users/`,
    GET_TEAMS_AVAILABILITY_TEAM: team_pk =>
      `teams/availability/team/?teams=${team_pk}`,
    GET_TEAMS_AVAILABILITY_ROLE: team_pk =>
      `teams/availability/roles/?teams=${team_pk}`,
    GET_TEAMS_SUMMARY: team_pk => `teams/team-summary/${team_pk}/`,
    GET_TEAMS_LIST: org_pk => `teams/${org_pk}/`,
    GET_TEAMS_LIST_ACCESS: `teams/list/access/`,
    GET_TEAMS_USER_LIST: `teams/users/list/`,
    GET_TEAMS_USERS_LIST: team_pk => `teams/users/${team_pk}/`,
    GET_TEAM: id => `teams/${id}/`,
    ADD_ORGUSER_TO_TEAM: org_pk => `teams/users/bulk/add/${org_pk}/`,
    POST_TEAMS_LIST: org_pk => `teams/${org_pk}/`,
    PATCH_TEAM: id => `teams/${id}/`,
    PATCH_TEAM_USERS: id => `teams/users/${id}/`,
    REMOVE_ORGUSER_FROM_TEAM: org_pk => `teams/users/bulk/delete/${org_pk}/`
  },

  PUBLIC_INDICES: {
    GET_PUBLIC_INDICES_LIST: `public_indices/list/`
  },

  GOALS: {
    GET_GOALS_LIST: org_pk => `goals/${org_pk}/`,
    POST_GOALS_LIST: org_pk => `goals/${org_pk}/`,
    PATCH_GOAL_EDIT: id => `goals/${id}/`,
    DELETE_GOAL: id => `goals/${id}/`
  },

  CUSTOMFIELDS: {
    GET_CUSTOMFIELDS_LIST: org_pk => `customfields/field/${org_pk}/`,
    GET_CUSTOMFIELDS_FILTERED_LIST: (org_pk, content_type) =>
      `customfields/field/${org_pk}/?content_type=${content_type}`,
    GET_CUSTOMFIELDS_VALUES: org_pk => `customfields/values/${org_pk}/`,

    POST_CUSTOMFIELD_LIST: org_pk => `customfields/field/${org_pk}/`,
    POST_CUSTOMFIELDS_VALUES: org_pk => `customfields/values/${org_pk}/`,

    PATCH_CUSTOMFIELD: id => `customfields/field/${id}/`,
    DELETE_CUSTOMFIELD: id => `customfields/field/${id}/`
  },

  NEWSLETTERS: {
    GET_NEWSLETTERS_LIST: org_pk => `newsletters/${org_pk}/`,
    POST_NEWSLETTERS_LIST: org_pk => `newsletters/${org_pk}/`,
    PATCH_NEWSLETTER: id => `newsletters/${id}/`,
    DELETE_NEWSLETTER: id => `newsletters/${id}/`
  },

  EXPENSES: {
    GET_EXPENSES_LIST_PK: () => `expenses/`,
    POST_EXPENSES_LIST_PK: org_pk => `expenses/groups/v2/${org_pk}/`,
    GET_EXPENSES_LIST: org_pk => `expenses/category/${org_pk}/`,
    GET_EXPENSES_GROUPS_LIST: org_pk => `expenses/groups/v2/${org_pk}/`,
    GET_EXPENSES_LIST_BY_GROUP: (team_pk, group_pk) =>
      `expenses/${team_pk}/${group_pk}/`,
    GET_EXPENSES_GROUPS: team_pk => `expenses/groups/${team_pk}/`,
    GET_CATEGORIES: id => `categories/?operation=${id}`,
    GET_CATEGORY_GROUPS: id =>
      id ? `categories/group/?operation=${id}` : `categories/group/`,

    GET_EXPENSES_CATEGORY: id => `expenses/category/${id}/`,
    EXPENSE: id => `expenses/${id}/`,

    GET_EXPENSES_MY_GROUPS_LIST: (orgId = '', query = '', id, page_size = 20) =>
      `expenses/my-groups/${id}/` +
      '?' +
      queryString({ orguser: orgId, page_size, q: query, team: id }),
    GET_EXPENSES_MY_GROUPS: team_pk => `expenses/my-groups/${team_pk}/`,

    GET_CATEGORY_GROUP: groupId => `categories/group/${groupId}/`,

    GET_EXPENSE: id => `expenses/groups/${id}/`,
    PATCH_EXPENSE_FILE: id => `expenses/groups/${id}/`,
    EXPENSE_DETAILS: (id, groupId) => `expenses/${id}/${groupId}/`,
    POST_EXPENSES_LIST: org_pk => `expenses/category/${org_pk}/`,
    POST_EXPENSES_GROUPS_ACTION: (org_pk, team_pk) =>
      `expenses/groups/list/action/${org_pk}/?team=${team_pk}`,
    POST_EXPENSES_MY_GROUPS: team_pk => `expenses/my-groups/${team_pk}/`,
    POST_EXPENSES_GROUPS: team_pk => `expenses/groups/${team_pk}/`,
    POST_CATEGORY_GROUPS: `categories/group/`,
    POST_CATEGORIES: `categories/`,

    POST_EXPENSES_ACTION: org_pk => `expenses/action/${org_pk}/`,

    PATCH_EXPENSE: id => `expenses/category/${id}/`,
    PATCH_EXPENSE_PK: id => `expenses/${id}/`,
    PATCH_EXPENSES_GROUP: id => `expenses/groups/${id}/`,
    PATCH_CATEGORY_GROUP: id => `categories/group/${id}/`,
    PATCH_CATEGORIES: id => `categories/${id}/`,

    DELETE_EXPENSE: id => `expenses/category/${id}/`,
    DELETE_EXPENSE_REPORT: id => `expenses/groups/${id}/`,
    DELETE_CATEGORY_GROUP: id => `categories/group/${id}/`,
    DELETE_CATEGORIES: id => `categories/${id}/`,
    EXPANSES_PDF: (orgPk, teamId, expensesId) =>
      `reports/preview/${orgPk}/?team=${teamId}&expense_group=${expensesId}`,
    GET_EXPENSES_GENERATE_PDF: id => `expenses/pdf/${id}/`,

    POST_EXPENSE: () => 'expenses/',
    GET_EXPENSE_WITH_ID: expenseId => `expenses/${expenseId}/`,

    POST_CATEGORY_TEMPLATE: () => 'categories/templates/',
    GET_CATEGORY_TEMPLATES: () => 'categories/templates/',
    GET_CATEGORY_TEMPLATE: templateId => `categories/templates/${templateId}/`,
    PATCH_CATEGORY_TEMPLATE: templateId =>
      `categories/templates/${templateId}/`,
    DELETE_CATEGORY_TEMPLATE: templateId =>
      `categories/templates/${templateId}/`,
    APPLY_CATEGORY_TEMPLATE: (templateId, operationId) =>
      `categories/templates/${templateId}/apply/operation/${operationId}/`,

    POST_GENERATE_TEMPLATE: operationId =>
      `/categories/templates/generate_from_operation/operation/${operationId}/`
  },

  BUDGETS: {
    GET_BUDGETS_LIST_PK: `budgets/year/`,
    PATCH_BUDGET: id => `budgets/year/${id}/`
  },

  INBOUND_EMAILS: {
    GET_INBOUND_EMAILS_LIST: org_pk => `inbound_emails/${org_pk}/`,
    POST_INBOUND_EMAILS_LIST: org_pk => `inbound_emails/${org_pk}/`,
    PATCH_INBOUND_EMAIL: id => `inbound_emails/${id}/`,
    DELETE_INBOUND_EMAIL: id => `inbound_emails/${id}/`
  },

  INVITATIONS: {
    GET_INVITATIONS_LIST: org_pk => `invitations/${org_pk}/`,
    POST_ACCEPT_INVITATION: code => `invitations/invitations/accept/${code}/`,
    POST_SET_PASSWORD: code => `invitations/set_password/${code}/`,
    DELETE_INVITATION: id => `invitations/${id}/`
  },

  JOBS: {
    GET_JOB_PK: id => `jobs/${id}/`,
    GET_JOBS_LIST_PK: org_pk => `jobs/${org_pk}/`,
    DELETE_JOBS_PK: id => `jobs/${id}/`,
    POST_JOBS__LIST_PK: org_pk => `jobs/${org_pk}/`,
    PATCH_JOB_PK: id => `jobs/${id}/`,

    GET_JOBS_INVOICES_LIST_PK: org_pk => `jobs/invoices/${org_pk}/`,
    GET_JOBS_INVOICES_PK: id => `jobs/invoices/${id}/`,
    GET_JOBS_INVOICES_ITEMS_LIST_PK: org_pk => `jobs/invoices/items/${org_pk}/`,
    POST_JOBS_INVOICES_LIST_PK: org_pk => `jobs/invoices/${org_pk}/`,
    POST_JOBS_INVOICES__ITEMS_LIST_TEAM_PK: (org_pk, team_pk) =>
      `jobs/invoices/items/${org_pk}/?team=${team_pk}`,
    PATCH_JOBS_INVOICES_PK: id => `jobs/invoices/${id}/`,
    PATCH_JOBS_INVOICES_ITEMS_PK: id => `jobs/invoices/items/${id}/`,
    DELETE_JOBS_INVOICES_PK: id => `jobs/invoices/${id}/`,
    DELETE_JOBS_INVOICES_ITEMS_PK: id => `jobs/invoices/items/${id}/`
  },

  REPORTS: {
    GET_REPORTS: proposalId => `reports/${proposalId}/`,
    GET_REPORTS_LIST: operationPk => `reports/list/${operationPk}/`,
    GET_REPORTS_VARIABLES: id => `reports/variables/${id}/`,
    GET_REPORTS_TEMPLATE: reportId => `reports/templates/${reportId}/`,
    GET_REPORTS_TEMPLATE_VARIABLES: reportId =>
      `reports/templates/variables/${reportId}/`,
    GET_REPORTS_TEMPLATES_LIST: teamPk => `reports/templates/${teamPk}/`,
    GET_REPORTS_TEMPLATES_LIST_PUBLIC: teamPk => `reports/templates/${teamPk}/`,
    GET_REPORTS_EXPORT: 'reports/export/',

    POST_REPORTS_PREVIEW: (orgPk, proposalId) =>
      `reports/preview/${orgPk}/?pk=${proposalId}`,
    POST_REPORTS_PREVIEW_BY_QUERY: `reports/preview/`,
    POST_REPORTS_PREVIEW_TEMPLATE: (orgPk, templateId) =>
      `reports/preview/?org=${orgPk}&template=${templateId}`,
    POST_REPORTS_LIST: (orgPk, projectId) =>
      `reports/${orgPk}/?project=${projectId}`,
    POST_GENERATE_REPORT: org_pk => `reports/generate/${org_pk}/`,
    POST_REPORTS_TEMPLATES_LIST: teamPk => `reports/templates/${teamPk}/`,
    POST_REPORTS_TEMPLATES_DUPLICATE: id =>
      `reports/templates/duplicate/${id}/`,

    PATCH_REPORT: id => `reports/${id}/`,
    PATCH_REPORT_TEMPLATE: id => `reports/templates/${id}/`,

    DELETE_REPORT: id => `reports/${id}/`,
    DELETE_REPORT_TEMPLATE: id => `reports/templates/${id}/`
  },

  PIPELINES: {
    GET_PIPELINES_LIST: org_pk => `pipelines/${org_pk}/`,
    GET_PIPELINES_STAGE_LIST: org_pk => `pipelines/stage/${org_pk}/`,
    POST_PIPELINES_STAGE_LIST: org_pk => `pipelines/stage/${org_pk}/`,
    PATCH_PIPELINES_STAGE: id => `pipelines/stage/${id}/`,
    DELETE_PIPELINES_STAGE: id => `pipelines/stage/${id}/`
  },

  CONTACTS: {
    // GET_CONTACTS_LIST_PK: org_pk => `contacts/${org_pk}/`,
    GET_CONTACTS_LIST_PK: () => `contacts/`,
    GET_CONTACTS_CATEGORIES_LIST: org_pk => `contacts/categories/${org_pk}/`,
    GET_CONTACT: id => `contacts/${id}/`,

    // POST_CONTACTS_LIST_PK: org_pk => `contacts/${org_pk}/`,
    POST_CONTACTS_LIST_PK: () => `contacts/`,
    PATCH_CONTACTS_PK: id => `contacts/${id}/`,
    DELETE_CONTACT: id => `contacts/${id}/`,

    POST_CONTACTS_CATEGORIES_LIST: org_pk => `contacts/categories/${org_pk}/`,
    PATCH_CONTACTS_CATEGORY: id => `contacts/category/${id}/`,
    DELETE_CONTACTS_CATEGORY: id => `contacts/category/${id}/`,

    POST_CONTACTS_LIST_ACTION: org_pk => `contacts/list-action/${org_pk}/`
  },

  BILLING: {
    GET_SUBSCRIPTION: org_pk => `billing/subscription/${org_pk}/`,
    GET_MANAGE_SUBSCRIPTION: (org_pk, customer_id) =>
      `billing/manage-subscription/${org_pk}/?customer_id=${customer_id}`,
    POST_CREATE_SUBSCRIPTION: (org_pk, price_id, quantity) =>
      `billing/create-subscription/${org_pk}/?price_id=${price_id}&quantity=${quantity}`
  },

  COSTS: {
    PATCH_COST_PK: cost_pk => `costs/${cost_pk}/`,
    DELETE_COST: cost_pk => `costs/${cost_pk}/`,
    GET_COST_LIST_PK: org_pk => `costs/${org_pk}/`,
    POST_COSTS_LIST: cost_pk => `costs/${cost_pk}/`,
    GET_COST_MONTH_PK: month_pk => `costs/month/${month_pk}/`,
    PATCH_COST_MONTH_PK: month_pk => `costs/month/${month_pk}/`,
    POST_COSTS_MONTH_LIST: org_pk => `costs/month/${org_pk}/`,
    // GET_COST_SUMMARY: () => `/costs/cost-summary/`,
    GET_COST_COMPOSITION: team_pk =>
      `/costs/cost-composition-charts/${team_pk}/`,
    POST_COSTS_COPY: org_pk => `costs/copy-prev-year/${org_pk}/`,
    POST_COPY_FROM_FEES: project_pk =>
      `costs/copy-fee-allocations-from-subcontractor-fees/${project_pk}/`,
    POST_COPY_FROM_HOURS: project_pk =>
      `costs/copy-fee-allocations-from-contract-hours/${project_pk}/`,
    POST_SET_ANNUAL_BUDGET: id => `costs/set-annual-budget/${id}/`
  },

  OPPORTUNITIES: {
    GET_PROJECTS_LEADS2: org_pk => `projects/leads2/${org_pk}/`
  },

  COMMENTS: {
    GET_ALL_COMMENTS: (type, object_type_pk) =>
      `comments/all/${type}/${object_type_pk}/`,
    POST_COMMENT: (type, object_type_pk) =>
      `comments/all/${type}/${object_type_pk}/`,
    PATCH_COMMENT: id => `comments/${id}/`,
    DELETE_COMMENT: id => `comments/${id}/`
  },

  FILES: {
    GET_FILES_FOLDER_LIST: project_pk =>
      project_pk
        ? `files/folder/list/?operation=${project_pk}`
        : `files/folder/list/`,
    GET_FILES_LIST: project_pk =>
      project_pk ? `files/list/?operation=${project_pk}` : `files/list/`,
    GET_FILES: () => `files/list/`,

    POST_FILES_FOLDER_LIST: `files/folder/list/`,
    POST_FILES_LIST: `files/list/`,

    PATCH_FOLDER: id => `files/folder/${id}/`,
    PATCH_FILE: id => `files/${id}/`,

    DELETE_FOLDER: id => `files/folder/${id}/`,
    DELETE_FILE: id => `files/${id}/`,
    DOWNLOAD_FILE: `files/download/`
  },

  DIGESTS: {
    GET_DIGESTS_INBOX_ALL: `digests/inbox/all/`,
    GET_DIGESTS_INBOX_UNREAD: `digests/inbox/unread/`,
    GET_DIGESTS_CONFIG: org_pk => `digests/digest-config/${org_pk}/`,

    PATCH_DIGESTS_CONFIG: org_pk => `digests/digest-config/${org_pk}/`,

    MARK_ALL_AS_READ: `digests/inbox/mark-all-as-read/`,
    MARK_ALL_AS_UNREAD: `digests/inbox/mark-all-as-unread/`,

    MARK_AS_READ: notification_pk =>
      `digests/inbox/mark-as-read/${notification_pk}/`,
    MARK_AS_UNREAD: notification_pk =>
      `digests/inbox/mark-as-unread/${notification_pk}/`,

    DELETE_DIGEST: notification_pk => `digests/inbox/delete/${notification_pk}/`
  },

  PLANS: {
    GET_PLANS_LIST_PROJECT_PK: project_pk => `plans/${project_pk}/`,
    GET_EXPORT_PLANS: project_pk => `plans/export/${project_pk}/`,
    POST_PLAN_LIST_ACTION: project_pk => `plans/list-action/${project_pk}/`,
    POST_PLAN_LIST: project_pk => `plans/${project_pk}/`,
    PATCH_PLAN: id => `plans/${id}/`,
    DELETE_PLAN: id => `plans/${id}/`
  },

  AREAS: {
    GET_AREAS_LIST_PROJECT_PK: project_pk => `areas/${project_pk}/`,
    POST_AREA_LIST: project_pk => `areas/${project_pk}/`,
    PATCH_AREA: id => `areas/${id}/`,
    DELETE_AREA: id => `areas/${id}/`
  },

  ZONES: {
    GET_ZONES_LIST_AREA_PK: area_pk => `zones/${area_pk}/`,
    GET_EXPORT_ZONES: project_pk => `zones/export/${project_pk}/`,
    POST_ZONE_LIST: area_pk => `zones/${area_pk}/`,
    PATCH_ZONE: id => `zones/${id}/`,
    DELETE_ZONE: id => `zones/${id}/`
  },

  DOCUMENTS: {
    GET_DOCUMENTS_LIST_PROJECT_PK: project_pk => `documents/${project_pk}/`,
    GET_EXPORT_DOCUMENTS: project_pk => `documents/export/${project_pk}/`,
    POST_GENERATE_DOCUMENTS: project_pk => `documents/generate/${project_pk}/`,
    POST_DOCUMENT_SET_PRICE: project_pk => `documents/set-price/${project_pk}/`,
    POST_DOCUMENT_LIST: project_pk => `documents/${project_pk}/`,
    PATCH_DOCUMENT: id => `documents/${id}/`,
    DELETE_DOCUMENT: id => `documents/${id}/`
  },

  QUICKBOOKS: {
    GET_DOWNLOAD_SAGE: 'quickbooks/download/sage/',
    GET_QUICKBOOKS_OAUTH: (org_pk, team_pk) =>
      `quickbooks/oauth/${org_pk}/${team_pk}/`,
    GET_QUICKBOOKS_REVOKE: (org_pk, team_pk) =>
      `quickbooks/revoke/${org_pk}/${team_pk}/`
  },

  HUBSPOT: {
    POST_HUBSPOT_USER: 'hubspot/get_user_token/'
  },
  SKILLS: {
    GET_SKILLS_LIST: org_pk => `skills/${org_pk}/`,
    GET_ORGUSERS_SKILLS_LIST: org_pk => `skills/orguser_skills/${org_pk}/`,

    POST_SKILLS_LIST: org_pk => `skills/${org_pk}/`,
    POST_ORGUSERS_SKILLS_LIST: org_pk => `skills/orguser_skills/${org_pk}/`,

    PATCH_SKILL: id => `skills/${id}/`,
    PATCH_ORGUSERS_SKILL: id => `skills/orguser_skills/${id}/`,

    DELETE_SKILL: id => `skills/${id}/`,
    DELETE_ORGUSERS_SKILL: id => `skills/orguser_skills/${id}/`
  },

  TRIPS: {
    GET_TRIPS_LIST: org_pk => `trips/${org_pk}/`,
    POST_TRIPS_LIST: (org_pk, team_pk) => `trips/${org_pk}/?team=${team_pk}`,
    PATCH_TRIP: id => `trips/${id}/`,
    DELETE_TRIP: id => `trips/${id}/`
  },

  FEES: {
    GET_FEES_LIST: project_pk => `fees/${project_pk}/`,
    GET_FEES_REVISIONS_LIST: fee_id => `fees/revisions/${fee_id}/`,
    GET_FEES_FFNE_ZONES: project_pk => `fees/zones/ffne/load/${project_pk}/`,
    GET_FEES_RULES: `fees/`,

    POST_FEES_LIST: project_pk => `fees/${project_pk}/`,
    POST_FEES_REVISIONS_LIST: fee_id => `fees/revisions/${fee_id}/`,
    POST_FEES_FFNE_ZONES_UPDATE: `fees/zones/ffne/update/`,
    POST_VALIDATE_FFNE: project_pk => `fees/validate_ffne/${project_pk}/`,
    POST_FEES_RULES: `fees/`,

    PATCH_FEE: id => `fees/${id}/`,
    PATCH_FEES_REVISION: id => `fees/revision/${id}/`,

    DELETE_FEE: id => `fees/${id}/`,
    DELETE_FEES_REVISION: id => `fees/revision/${id}/`
  },

  LEASES: {
    POST_LEASE: () => `leases/`,
    POST_LEASE_ARTICLES: leaseId => `/leases/${leaseId}/articles/`,

    // GET_LEASES_LIST: () => `leases/`,
    GET_LEASE: leaseId => `leases/${leaseId}/`,
    GET_LEASE_PERIODS: leaseId => `leases/${leaseId}/periods/`,
    GET_LEASE_ARTICLES: leaseId => `/leases/${leaseId}/articles/`,
    GET_LEASE_SCHEDULE: leaseId => `/leases/${leaseId}/schedule/`,
    GET_LEASES_LIST: operationId =>
      operationId ? `leases/?operation=${operationId}` : 'leases/',
    GET_LEASES_PERIODS: () => `/leases/periods/all/`,

    PATCH_LEASE_ARTICLE: (leaseId, articleId) =>
      `leases/${leaseId}/articles/${articleId}/`,

    DELETE_LEASE_PERIOD: (leaseId, periodId) =>
      `leases/${leaseId}/periods/${periodId}/`,
    DELETE_LEASE_ARTICLE: (leaseId, articleId) =>
      `leases/${leaseId}/articles/${articleId}/`
  },

  DISCOUNTS: {
    POST_DISCOUNT: () => `discounts/`,

    GET_DISCOUNT_LIST: () => `discounts/`,

    GET_DISCOUNT: discountId => `discounts/${discountId}/`,

    PATCH_DISCOUNT: discountId => `discounts/${discountId}/`,

    DELETE_DISCOUNT: discountId => `discounts/${discountId}/`
  },

  LANDLORDS: {
    POST_LANDLORD: () => `landlords/`,

    GET_LANDLORDS_LIST: () => `landlords/`,
    GET_LANDLORDS_LIST_BY_PROJECT: id => `landlords/?operations=${id}`,
    GET_LANDLORD_BY_ID: id => `landlords/${id}/`,
    GET_PROJECT_LANDLORDS: id => `landlords/?operations=${id}`,
    GET_ALL_LANDLORDS: `landlords/`,

    // GET_LANDLORD_INVOICES: landlordId => `invoices/?landlord=${landlordId}`,
    // GET_LANDLORD_PAYMENTS: landlordId => `payments/?landlord=${landlordId}`,
    GET_LANDLORD_LEASES: landlordId => `leases/?landlord=${landlordId}`,
    GET_LEASES: () => `leases/`,
    GET_LANDLORD_MANDATES: landlordId => `mandates/?landlord=${landlordId}`,
    // GET_LANDLORD_TASKS: landlordId => `tasks/?landlord=${landlordId}`,
    GET_LANDLORD_TASKS: () => `tasks/`,

    PATCH_LANDLORD_BY_ID: id => `landlords/${id}/`,
    PATCH_LANDLORD: id => `landlords/${id}/`,
    PATCH_LANDLORD_FILE: id => `landlords/${id}/`,
    // PATCH_LANDLORD_FILE: id => `landlords/${id}/`,

    DELETE_LANDLORD_BY_ID: id => `landlords/${id}/`,
    DELETE_LANDLORD: id => `landlords/${id}/`
  },

  CATEGORIES: {
    GET_CATEGORIES: () => `categories/`
  },

  BUILDINGS: {
    GET_BUILDINGS: () => `buildings/`,
    GET_BUILDING: buildingId => `buildings/${buildingId}/`,

    POST_BUILDING: () => `buildings/`,

    PATCH_BUILDING: buildingId => `buildings/${buildingId}/`,

    DELETE_BUILDING: buildingId => `buildings/${buildingId}/`
  },

  FLOORS: {
    GET_FLOORS: () => `floors/`,
    GET_FLOOR: floorId => `floors/${floorId}/`,

    POST_FLOOR: () => `floors/`,

    PATCH_FLOOR: floorId => `floors/${floorId}`,

    DELETE_FLOOR: floorId => `floors/${floorId}`
  },

  LOTS: {
    POST_LOT: () => `lots/`,
    POST_LOT_GROUP: () => `lots/groups/`,
    GET_LOT_PK: id => `lots/${id}/`,
    GET_ALL_LOTS: `lots/`,
    GET_LOTS_LIST: () => `lots/`,
    GET_LOTS: () => `lots/`,
    PATCH_LOT: lotId => `lots/${lotId}/`,
    PATCH_LOT_GROUP: lotId => `lots/groups/${lotId}/`,
    GET_LOT: lotId => `lots/${lotId}/`,
    GET_LOT_GROUPS: () => `lots/groups/`,
    GET_LOT_GROUP: lotGroupId => `lots/groups/${lotGroupId}/`,
    GET_LOT_BUDGETS: (lotId, year) => `lots/${lotId}/budget/${year}/`,
    DELETE_LOT: lotId => `lots/${lotId}/`,
    DELETE_LOT_GROUP: lotId => `lots/groups/${lotId}/`
  },

  CASHFLOW: {
    GET_TRANSACTIONS: () => `treasuries/transactions/`,
    PATCH_TRANSACTION: transactionId =>
      `treasuries/transactions/${transactionId}/`,
    GET_METRICS: () => `metrics/cashflow_chart/`
  },

  FINANCE: {
    GET_METRICS: () => `metrics/operation_finance/`,
    GET_SALES_STATS: () => `metrics/operation_finance/sales_stats/`
  },

  ALERTS: {
    GET_ALERTS: () => `alerts/`,
    DUE_TASKS: operationId => `alerts/due_task/${operationId}/`,
    LATE_INVOICES: operationId => `alerts/late_invoice/${operationId}/`,
    EXPIRING_LEASES: () => `alerts/lease_expiration/`
  },

  MORTGAGES: {
    GET_MORTGAGES: () => `mortgages/`,
    GET_MORTGAGE: mortgageId => `mortgages/${mortgageId}/`,

    POST_MORTGAGE: () => `mortgages/`,

    PATCH_MORTGAGE: mortgageId => `mortgages/${mortgageId}/`,

    DELETE_MORTGAGE: mortgageId => `mortgages/${mortgageId}/`
  },

  METRICS: {
    GET_EXPENSE_METRICS: () => `metrics/expense/`,
    GET_INVOICE_METRICS: () => `metrics/invoice/`,
    GET_MANAGER_REVENUE: () => `metrics/manager/revenue/`
  },

  VISITS: {
    GET_VISITS: () => `visits/`,
    GET_VISIT: visitId => `visits/${visitId}/`,

    POST_VISIT: () => `visits/`,

    PATCH_VISIT: visitId => `visits/${visitId}/`,

    DELETE_VISIT: visitId => `visits/${visitId}/`
  },
  TICKETS: {
    POST_TICKET: () => `tickets/`,

    GET_TICKETS: () => `tickets/`,
    GET_TICKET: ticketId => `tickets/${ticketId}/`,

    POST_TICKETS_ACTION: org_pk => `tickets/action/${org_pk}/`,

    PATCH_TICKET: ticketId => `tickets/${ticketId}/`,

    DELETE_TICKET: ticketId => `tickets/${ticketId}/`
  },
  INVESTORS: {
    GET_INVESTORS: () => `investors/`,
    GET_INVESTOR: investorId => `investors/${investorId}/`,
    GET_SHARES: () => `investors/share/`,
    GET_SHARE: shareId => `investors/share/${shareId}/`,
    GET_INVENTOR_TASKS: () => `tasks/`,

    POST_INVESTOR: () => `investors/`,
    POST_SHARE: () => `investors/share/`,

    PATCH_INVESTOR: investorId => `investors/${investorId}/`,
    PATCH_SHARE: shareId => `investors/share/${shareId}/`,

    DELETE_INVESTOR: investorId => `investors/${investorId}/`,
    DELETE_SHARE: shareId => `investors/share/${shareId}/`
  },

  METERS: {
    POST_METER: () => `meters/`,
    POST_METER_READINGS: () => `meters/revision/`,

    GET_METERS: () => `meters/`,
    GET_METER: meterId => `meters/${meterId}/`,
    GET_METER_READINGS: () => `meters/revision/`,
    GET_METER_READING: readingId => `meters/revision/${readingId}/`,

    PATCH_METER: meterId => `meters/${meterId}/`,
    PATCH_METER_READING: readingId => `meters/revision/${readingId}/`,

    DELETE_METER: meterId => `meters/${meterId}/`,
    DELETE_METER_READING: readingId => `meters/revision/${readingId}/`
  }
}

export default API_URL
